import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const isLocalhost = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(
  window.location.hostname
);
const isSecureContext =
  window.location.protocol === "https:" || isLocalhost;

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    if (process.env.NODE_ENV === "production" && isSecureContext) {
      navigator.serviceWorker
        .register("/serviceWorker.js")
        .then((registration) => {
          console.log(
            "Service Worker registrado con éxito:",
            registration.scope
          );
        })
        .catch((error) => {
          console.log("Error al registrar el Service Worker:", error);
        });
      return;
    }

    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  });
}
